import { render, staticRenderFns } from "./NotificationAlertsTable.vue?vue&type=template&id=67d71d22"
import script from "./NotificationAlertsTable.vue?vue&type=script&lang=ts"
export * from "./NotificationAlertsTable.vue?vue&type=script&lang=ts"
import style0 from "./NotificationAlertsTable.vue?vue&type=style&index=0&id=67d71d22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports